'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('vendor-show', {
      url: '/vendor/:id',
      template: '<vendor-show></vendor-show>',
      authenticate: true
    });
}



// WEBPACK FOOTER //
// ./client/app/portfolio/vendor-show/vendor-show.routes.js